export const domain = `${window.location.protocol}//${window.location.host}`;

export const passwordEncryptionKey = `${process.env
  .REACT_APP_PASSWOR_DENCRYPTION_KEY!}`;

export const API_HOST = `${process.env.REACT_APP_API_HOST!}`;

export const LOGIN_PAGE = `${domain}/login`;

export const SIGNUP_PAGE = `${domain}/register`;

export const ACCOUNT_PAGE = `${domain}/account`;

window.__MOLSTAR_BACKEND_HOST__ = API_HOST;
